import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "h-100 py-4 px-3" };
const _hoisted_2 = {
    class: "container flex-grow-1",
    style: { "max-width": "1200px" }
};
const _hoisted_3 = { class: "row mb-4 justify-content-center animate__animated animate__fadeInUp" };
const _hoisted_4 = { class: "col-lg-8" };
const _hoisted_5 = {
    class: "card border-0 shadow-sm overflow-hidden",
    style: { "border-radius": "16px" }
};
const _hoisted_6 = { class: "card-body p-3 d-flex align-items-center justify-content-between bg-light" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = ["value"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_11 = {
    key: 1,
    class: "row g-4 animate__animated animate__fadeInUp"
};
const _hoisted_12 = { class: "col-lg-6" };
const _hoisted_13 = { class: "col-lg-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IntegrationCard = _resolveComponent("IntegrationCard");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"row mb-4 animate__animated animate__fadeIn\" data-v-b7a47e86><div class=\"col-12 text-center\" data-v-b7a47e86><div class=\"card bg-gradient-dark text-white border-0 shadow-sm overflow-hidden\" style=\"border-radius:20px;\" data-v-b7a47e86><div class=\"card-body p-4 position-relative\" data-v-b7a47e86><div class=\"d-flex flex-column align-items-center text-center\" data-v-b7a47e86><div class=\"bg-white bg-opacity-25 p-3 rounded-circle mb-3\" data-v-b7a47e86><i class=\"flaticon-settings fs-1 text-white\" data-v-b7a47e86></i></div><div data-v-b7a47e86><h2 class=\"fw-bold mb-1 text-white\" data-v-b7a47e86>Intégrations Marketplaces</h2><p class=\"mb-0 opacity-75 text-white\" data-v-b7a47e86>Synchronisez vos commandes Uber Eats et Just Eat avec votre système Va Bene.</p></div></div></div></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "flaticon-pin me-2 text-primary fs-5" }, null, -1)),
                                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-bold text-dark me-2" }, "Configuration pour :", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedRestaurantId) = $event)),
                                    class: "form-select form-select-sm border-0 border-bottom bg-transparent fw-bold",
                                    style: { "width": "auto", "min-width": "200px" },
                                    onChange: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.loadIntegrations && _ctx.loadIntegrations(...args)))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: res.id,
                                            value: res.id
                                        }, _toDisplayString(res.name), 9, _hoisted_8));
                                    }), 128))
                                ], 544), [
                                    [_vModelSelect, _ctx.selectedRestaurantId]
                                ])
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.loadIntegrations && _ctx.loadIntegrations(...args))),
                                class: "btn btn-white btn-sm shadow-sm border",
                                disabled: _ctx.loading
                            }, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                                    _createTextVNode(" Actualiser ", -1)
                                ]))], 8, _hoisted_9)
                        ])
                    ])
                ])
            ]),
            (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("div", {
                            class: "spinner-border text-primary",
                            role: "status"
                        }, null, -1),
                        _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement de la configuration...", -1)
                    ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_IntegrationCard, {
                            platform: "UBEREATS",
                            name: "Uber Eats (Suisse)",
                            description: "Réception automatique des commandes et gestion de la livraison.",
                            "icon-class": "flaticon-shopping-cart-2",
                            color: "#000000",
                            integration: _ctx.getIntegration('UBEREATS'),
                            onSave: _ctx.saveConfig,
                            onPing: _ctx.testPing
                        }, null, 8, ["integration", "onSave", "onPing"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_IntegrationCard, {
                            platform: "JUSTEAT",
                            name: "Just Eat Suisse",
                            description: "Le plus grand réseau de livraison en Suisse, intégré à votre POS.",
                            "icon-class": "flaticon-trolley-cart",
                            color: "#f36d00",
                            integration: _ctx.getIntegration('JUSTEAT'),
                            onSave: _ctx.saveConfig,
                            onPing: _ctx.testPing
                        }, null, 8, ["integration", "onSave", "onPing"])
                    ])
                ]))
        ])
    ]));
}
